export const ARTIFACT_MOCK_SOURCE = `import {
  Badge,
  Card,
  Checkbox,
  Grid,
  List,
  Section,
  Stat,
  Text,
  YStack,
  useCanvasState,
} from 'littlebird/canvas';

const HIGHLIGHTS = [
  { label: 'In review', value: 4, delta: +2 },
  { label: 'Shipped this week', value: 11, delta: +3 },
  { label: 'Blocked', value: 1, delta: -1, goodDirection: 'down' },
];

const THREADS = [
  { id: 'a', title: 'Pricing page copy', subtitle: 'waiting on you', meta: '2h' },
  { id: 'b', title: 'Q3 roadmap review', subtitle: 'three replies', meta: '5h' },
];

const Canvas = () => {
  const [done, setDone] = useCanvasState<string[]>('done', []);

  return (
    <YStack gap={5} padding={8} maxWidth={900}>
      <Section
        title="This week"
        description="A quick read on where everything landed"
        badge={<Badge status="success">On track</Badge>}
      />

      <Grid columns={3} gap={3}>
        {HIGHLIGHTS.map((stat) => (
          <Stat key={stat.label} {...stat} />
        ))}
      </Grid>

      <Section title="Worth a second look" description="oldest first">
        <List items={THREADS} />
      </Section>

      <Card title="Before you log off">
        {THREADS.map((thread) => (
          <Checkbox
            key={thread.id}
            label={thread.title}
            checked={done.includes(thread.id)}
            onChange={() => setDone([...done, thread.id])}
          />
        ))}
        <Text tone="muted">Two threads are waiting on a reply.</Text>
      </Card>
    </YStack>
  );
};

export default Canvas;
`;
